import React, { useEffect } from "react";
import { Col, Row } from "react-bootstrap";
import { ConfirmContainer } from "./style";
import SelectedProduct from "components/selectedProduct";
import Button from "components/button";
import UserData from "./components/userData";
// import ReCAPTCHA from "react-google-recaptcha";
import { FiEdit3 } from "react-icons/fi";
import Modal from "components/modal";
import GetwaySelect from "components/gatwaySelect";
const Confirm = ({
  selectedOptions,
  product,
  selectedDealer,
  prev,
  recaptcha,
  submit,
  goTo,
  loading,
  showPic,
  gateways,
  selectedGeteway,
  setGeteway,
}) => {
  const [modalStatus, setModalStatus] = React.useState(false);
  const [policyStatus, setPolicyStatus] = React.useState(false);
  // const recaptchaRef = React.createRef();
  // const [recaptchaValue, setRecaptchaValue] = React.useState(null);
  // useEffect(() => {
  //   const resetCaptcha = () => {
  //     if (!loading && recaptchaValue) {
  //       recaptchaRef.current.reset();
  //       setRecaptchaValue(null);
  //     }
  //   };
  //   resetCaptcha();
  // }, [loading]);
  return (
    <ConfirmContainer>
      <div className="title">
        <h5>تایید اطلاعات</h5>
      </div>
      <SelectedProduct
        selectedOptions={selectedOptions}
        product={product}
        goTo={() => goTo("list")}
        showPic={showPic}
      />
      <div className="dealer-box">
        <h5>{selectedDealer.title}</h5>
        <FiEdit3 className="edit-icon" onClick={() => goTo("dealer")} />
        <Row>
          <Col sm={12} md={5}>
            <div className="text">
              کد نمایندگی: {selectedDealer.description}
            </div>
            <div className="phone">تلفن: {selectedDealer.phone}</div>
          </Col>
          <Col sm={12} md={7}>
            <div className="province-city">
              استان: {selectedDealer.province} - شهر: {selectedDealer.city}
            </div>
            <div className="address">آدرس: {selectedDealer.address}</div>
          </Col>
        </Row>
      </div>
      <UserData goTo={() => goTo("form")} />
      <div className="recaptcha">
        <div className="policy">
          <input
            type="checkbox"
            checked={policyStatus}
            onChange={() => setPolicyStatus(!policyStatus)}
          />
          <label>
            متن
            <span
              onClick={(e) => {
                e.stopPropagation();
                setModalStatus(true);
              }}
            >
              {" "}
              توافق نامه{" "}
            </span>
            را مطالعه کرده و مورد تایید می باشد
          </label>
        </div>
        {/* <ReCAPTCHA
          sitekey={recaptcha}
          onChange={setRecaptchaValue}
          ref={recaptchaRef}
        /> */}
      </div>
      <GetwaySelect
        gateways={gateways}
        selected={selectedGeteway}
        setGeteway={setGeteway}
      />
        {/*
        <div className="sample-contract">
            <a href="/pdf/sample-contract.pdf">دانلود نمونه پیشنویس قرارداد</a>
        </div>
        */}
      <div className="buttons">
        <Button title="مرحله قبل" onClick={prev} />
        <Button
          disabled={ !policyStatus}
          loading={loading}
          title="ثبت نهایی"
          onClick={() => submit()}
        />
      </div>
      <Modal
        status={modalStatus}
        size="big"
        close={() => setModalStatus(false)}
      >
        <div dangerouslySetInnerHTML={{ __html: product?.note }} />
      </Modal>
    </ConfirmContainer>
  );
};
export default Confirm;
